import type { Transition } from 'framer-motion';
import { motion } from 'framer-motion';
import type { FunctionComponent } from 'react';

const transition: Transition = {
    duration: 4,
    ease: 'easeInOut',
    repeat: Number.POSITIVE_INFINITY,
};

export const PulsatingCircle: FunctionComponent = () => {
    return (
        // biome-ignore lint/a11y/noSvgWithoutTitle: suppressed due to migration
        <svg height={20} viewBox="0 0 200 200" width={20}>
            <motion.circle
                animate={{ r: [50, 70, 50] }}
                cx="100"
                cy="100"
                fill="#FEA98F"
                r={50}
                transition={transition}
            />
        </svg>
    );
};
